import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GeneralService } from '@app/@shared/services/general.service';
import { SorteoService } from '@app/@shared/services/sorteo.service';
import { TotalGameService } from '@app/@shared/services/total-game.service';
import { environment } from '@env/environment';
import { AlertController } from '@ionic/angular';

import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { CredentialsService } from '@app/auth/credentials.service';
import { SorteoType, SorteoZodiac } from '@app/@shared/models/sorteo.model';
import { TranslateService } from '@ngx-translate/core';

import { Logger } from '@app/@shared/logger.service';

const log = new Logger('PickerComponentLotenal');
@Component({
  selector: 'app-picker',
  templateUrl: './picker.component.html',
  styleUrl: './picker.component.scss',
})
export class PickerComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Output() pickerChange = new EventEmitter<any>();
  @Output() zodiacChange = new EventEmitter<string>();
  @Output() reservationResult = new EventEmitter<any>();
  @Output() ghostReservationResult = new EventEmitter<any>();
  @Output() emptyNumber = new EventEmitter<string>();
  @Output() loadingTicket = new EventEmitter<boolean>();

  readonly EMPTY_SIGN = {
    name: 'Elige tu signo', // Asegúrate que no esté vacío
    idSigno: null,
    icon: '', // Añade este campo si los ítems del zodiaco lo tienen
  };

  @Input() notDraw = false;
  @Input() isDoingTermination = false;
  @Input() type?: SorteoType;
  @Input() recommendedNumbers: { numbers: number[]; category?: string } | number[] = [];
  @Input() favoriteNumbers: number[] = [];
  @Input() selectedDraw: any;
  @Input() draws: any[] = [];
  @Input() values: any[] = [];
  @Input() sorteoS?: SorteoService;
  @Input() generalS?: GeneralService;
  @Input() credentialsS?: CredentialsService;
  @Input() value: any[] = [];
  @Input() isZodiac = false;
  @Input() isGranEspecial = false;
  @Input() valueZodiac: { name: string; idSigno: number | null } = { name: '', idSigno: null };

  showZodiacPicker = true;
  zodiac: SorteoZodiac[] = [];
  lastReservation: {
    tipoSorteo: number;
    numeroSorteo: number;
    numeroBillete: string;
    signo: number;
  } | null = null;
  size: number[] = [];
  isReservationInProgress = false;
  isResetting = false;

  isReturningFromPayment = false;
  previousUrl = ''; // Variable para guardar la ruta anterior
  isLoadingTicket = false;
  private refCounter = 1;
  zodiacZero = true;
  isRecommended: boolean = false;

  constructor(
    private totalS: TotalGameService,
    private alertCtrl: AlertController,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.checkPickerZodiac();
    this.zodiac = this.sorteoS?.zodiac || [];
    this.value = Array(this.value.length).fill(0);
    this.size = Array(this.value.length).fill(0);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.previousUrl = this.router.url;
      }

      if (event instanceof NavigationEnd) {
        // Verificar si la ruta anterior era /payment
        this.isReturningFromPayment = this.previousUrl.includes('/payment');
        if (this.isReturningFromPayment) {
          this.checkPickerZodiac();
          this.resetZodiacPicker();
          //  this.zodiacZero = true;
          this.value = Array(this.value.length).fill(0);
          this.pickerChange.emit(' ');
          this.emptyNumber.emit(' ');
        } else {
          // También resetea al inicio si no viene de payment
          this.resetZodiacPicker();
        }
      }
      if (event instanceof NavigationEnd) {
        //    this.zodiacZero = true;
        this.checkPickerZodiac();
        // Verificar si la ruta anterior era /payment
        this.isReturningFromPayment = this.previousUrl.includes('/payment');
        this.emptyNumber.emit(' ');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['recommendedNumbers'] && changes['recommendedNumbers'].currentValue?.length) ||
      (changes['recommendedNumbers'] && changes['recommendedNumbers'].currentValue?.numbers?.length)
    ) {
      const current = changes['recommendedNumbers'].currentValue;

      // Caso Zodiaco (objeto con numbers y category)
      if (current && typeof current === 'object' && 'numbers' in current) {
        this.value = [...current.numbers];

        // Asignar el signo zodiacal correspondiente
        if (current.category) {
          const zodiacSign = this.zodiac.find((sign) => sign.name.toLowerCase() === current.category.toLowerCase());

          if (zodiacSign) {
            this.valueZodiac = zodiacSign;
            this.isRecommended = true;
            this.zodiacZero = false;
          }
        }
      }
      // Caso Array normal
      else if (Array.isArray(current)) {
        this.value = [...current];
        // Resetear el signo si es necesario
        this.valueZodiac = { name: '', idSigno: null };
      }

      if (this.value.length > 0) {
        // this.reservExactNumber();
      }
    }

    // Verificar cambios en 'favoriteNumbers' y aplicar cambios
    if (changes['favoriteNumbers'] && changes['favoriteNumbers'].currentValue) {
      changes['favoriteNumbers'].currentValue.map((item: any) => {
        this.value = item.value;

        // Detectar signo zodiacal por icono (para favoritos)
        if (item.icon) {
          const zodiacSign = this.zodiac.find(
            (sign) => this.normalizeText(sign.name) === this.normalizeText(item.icon)
          );

          if (zodiacSign) {
            this.valueZodiac = zodiacSign;
            this.isRecommended = true;
            this.zodiacZero = false;
          }
        }
      });
    }

    // Verificar cambios en 'selectedDraw' y actualizar si es necesario
    if (changes['selectedDraw'] && changes['selectedDraw'].currentValue) {
      const newSelectedDraw = changes['selectedDraw'].currentValue;
      //   console.log('Nuevo sorteo seleccionado en PickerComponent:', newSelectedDraw);

      // Solo hacer la reserva fantasma si `newSelectedDraw` es válido
      if (newSelectedDraw.numeroSorteo) {
        this.makeGhostReservation(newSelectedDraw);
      }
    }

    if (changes['isDoingTermination']) {
      this.isDoingTermination = changes['isDoingTermination'].currentValue;
    }
  }

  ngAfterViewInit() {
    const len = this.value.length;
    document.documentElement.style.setProperty('--columns', len.toString());
  }
  normalizeText = (text: string) =>
    text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  resetZodiacPicker() {
    this.showZodiacPicker = false;
    this.valueZodiac = { ...this.EMPTY_SIGN };
    this.cdr.detectChanges();

    setTimeout(() => {
      this.showZodiacPicker = true;
      // Fuerza cambio de referencia
      this.valueZodiac = { ...this.EMPTY_SIGN };
      this.cdr.detectChanges();
    }, 100);
  }

  compareZodiac(a: any, b: any): boolean {
    // Caso cuando ambos son EMPTY
    if (a?.idSigno === -1 && b?.idSigno === -1) return true;
    // Caso cuando uno es EMPTY
    if (a?.idSigno === -1 || b?.idSigno === -1) return false;
    // Comparación normal
    return a?.idSigno === b?.idSigno;
  }

  checkTerminationStatus(): void {
    if (this.isDoingTermination) {
      log.info('Termination is active');
    } else {
      log.info('Termination is inactive');
    }
  }

  checkPickerZodiac() {
    if (this.selectedDraw?.tipoSorteo === 4) {
      this.zodiacZero = true;
    } else {
      this.zodiacZero = false;
    }
  }
  isPickerDisabled(index: number): boolean {
    if (!this.isDoingTermination) {
      // Si no está en modo "termination", todos los pickers están habilitados
      return false;
    }

    // Si el tipo es "zodiaco" o "zodiaco-especial", solo los últimos 2 están habilitados
    if (this.type === 'zodiaco' || this.type === 'zodiaco-especial') {
      return index < this.value.length - 2;
    }

    // Para otros tipos, solo los últimos 3 están habilitados
    return index < this.value.length - 3;
  }

  updatePickers(numbers: number[]): void {
    this.value = [...numbers];
  }

  getColumnSize(): string {
    const len = this.value.length;
    const columnSize = this.isZodiac ? 12 / (len + 1) : 12 / len;
    return `${columnSize}`;
  }

  trackByFn(index: number, item: any) {
    return index;
  }

  // picker.component.ts
  changePicker(i: number, ev: CustomEvent) {
    if (this.isResetting || this.isReservationInProgress) return;
    if (!Array.isArray(this.value)) return;

    const newValue: any = [...this.value];
    const selectedValue = ev.detail.value;

    if (newValue[i] === selectedValue) {
      return;
    }

    newValue[i] = (selectedValue + 10) % 10;
    this.value = newValue;
    this.pickerChange.emit([...this.value]);

    // const isInitialState = this.value.every((v: any) => v === 0);
    // if (isInitialState) {
    //   return;
    // }

    if (this.isReturningFromPayment) {
      this.isReturningFromPayment = false;
    }

    // Llamar a reservExactNumber sin parámetros
    // if (this.isDoingTermination) {
    //   this.reservNumberTermination();
    // }
    // {
    //   this.reservExactNumber();
    // }
  }

  getCircularNumbers(selectedNumber: any): number[] {
    const numbers = [];
    const totalNumbers = 10; // Números del 0 al 9

    selectedNumber = (selectedNumber + totalNumbers) % totalNumbers;

    // Agregar los  números anteriores
    for (let i = 9; i > 0; i--) {
      numbers.push((selectedNumber + totalNumbers - i) % totalNumbers);
    }

    numbers.push(selectedNumber);

    for (let i = 1; i <= 9; i++) {
      numbers.push((selectedNumber + i) % totalNumbers);
    }

    return numbers;
  }

  // picker.component.ts
  changePickerZodiac(ev: CustomEvent) {
    const selectedZodiac = ev.detail['value'];
    // Verificar si el signo zodiacal es inválido
    if (!selectedZodiac.idSigno || selectedZodiac.name === '') {
      this.zodiacZero = true; // Cambiar a true cuando se selecciona "Elige tu signo"
      // en true desactiva el boton
    } else {
      this.zodiacZero = false; // Cambiar a false para signos válidos
    }

    // Evitar emitir cambios si el signo seleccionado es el mismo
    if (this.valueZodiac?.idSigno === selectedZodiac.idSigno) {
      return;
    }

    this.valueZodiac = selectedZodiac;
    this.pickerChange.emit({ numbers: [...this.value], zodiac: this.valueZodiac });

    if (this.isReturningFromPayment) {
      this.isReturningFromPayment = false;
    }

    // if (this.isDoingTermination) {
    //   this.reservNumberTermination();
    // }
    // {
    //   this.reservExactNumber();
    // }
  }
  async searchNumber() {
    this.isLoadingTicket = true;

    // if (!this.value || (Array.isArray(this.value) && this.value.every((num) => num === 0))) {
    //   this.showAlert('ALERT.ERROR', 'ALERT.NO_NUMBERS_SELECTED');
    //   this.isLoadingTicket = false;
    //   return;
    // }

    // Solo ajustar si son valores numéricos
    this.value = this.value.map((val: any) => (typeof val === 'number' ? (val + 10) % 10 : val));

    // console.log('this.value: ', this.value);

    // Emitir según tipo
    if (this.isZodiac) {
      this.pickerChange.emit({ numbers: [...this.value], zodiac: this.valueZodiac });
    } else {
      this.pickerChange.emit([...this.value]);
    }

    // const isInitialState = this.value.every((v: any) => v === 0);
    // if (isInitialState) return;

    if (this.isReturningFromPayment) this.isReturningFromPayment = false;

    if (this.isDoingTermination) {
      await this.reservNumberTermination();
      this.pausePicker();
    } else {
      await this.reservExactNumber();
      this.pausePicker();
    }
  }

  async reservExactNumber() {
    if (!this.selectedDraw) {
      console.error('No selected draw available for reservation.');
      this.isLoadingTicket = false;
      this.isReservationInProgress = false;
      this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');
      return;
    }
    if (this.valueZodiac?.idSigno === null && this.selectedDraw.tipoSorteo === 4) {
      //console.log('reservExactNumber: signo is null for zodiac draw');
      this.isLoadingTicket = false;
      this.isReservationInProgress = false;
      this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');
      return;
    }

    if (this.isReservationInProgress || this.isReturningFromPayment) {
      return;
    }

    // Evitar reservas si el número es 0000
    const numeroBillete = this.value.map((v: any) => (v === -1 ? '0' : v.toString())).join('');
    // if (numeroBillete === Array(this.value.length).fill('0').join('')) {
    //   return;
    // }
    if (this.selectedDraw.tipoSorteo === 4 && this.valueZodiac?.idSigno === 0 && this.valueZodiac?.idSigno === null) {
      this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');
      return;
    }
    this.isReservationInProgress = true;

    try {
      const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
      const counter = await this.generalS?.counterRefCode();
      const textCounter = `${idPrefix}${counter}`;
      const body = {
        lnRequestRB: {
          requestHeadTerminal: {
            // idTerminal: 1234567890123,
            idTerminal: this.credentialsS?.credentials?.id || '',
            ov: environment.userLotenal.ov,
            usuario: environment.userLotenal.user,
            password: environment.userLotenal.password,
            refCode: `exact-reservation-${this.selectedDraw.numeroSorteo}-${textCounter}`,
          },
          tipoSorteo: this.selectedDraw.tipoSorteo,
          numeroSorteo: this.selectedDraw.numeroSorteo,
          numeroBillete,
          signo: this.valueZodiac?.idSigno || 0,
          cantBilletesReservar: 4,
          codEstado: 9,
        },
      };

      const response = await this.sorteoS?.reservExactNumber(body);
      this.reservationResult.emit(response);
      this.lastReservation = {
        tipoSorteo: this.selectedDraw.tipoSorteo,
        numeroSorteo: this.selectedDraw.numeroSorteo,
        numeroBillete,
        signo: this.valueZodiac?.idSigno || 0,
      };

      const billetes = response?.lnResponseRE?.billete || [];
      const hayDiferencia = billetes.some((b: any) => this.value.join('') !== b.numeroBillete.toString());
      if (hayDiferencia) {
        this.emptyNumber.emit('El número seleccionado no se encontró. Te sugerimos otro.');
      } else {
        this.emptyNumber.emit(' ');
      }

      const isTicketZodiac = this.sorteoS?.validateTicketLotenal(
        response,
        this.selectedDraw.numeroSorteo,
        this.selectedDraw.tipoSorteo
      );
      if (!isTicketZodiac) {
        const idTransaccion = response?.lnResponseRE?.idTransaccion || response?.lnResponseRB?.idTransaccion;
        if (idTransaccion) {
          await this.sorteoS?.releaseTickets(idTransaccion, this.selectedDraw?.numeroSorteo);
        }

        this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');

        return;
      }

      return response;
    } catch (error) {
      console.error('Error en la reserva:', error);
      return this.totalS.validateMessageIgt({ errorRetries: true });
    } finally {
      this.isLoadingTicket = false;
      this.isReservationInProgress = false;
    }
  }

  async reservNumberTermination() {
    if (this.valueZodiac?.idSigno === null && this.selectedDraw.tipoSorteo === 4) {
      //console.log('reservExactNumber: signo is null for zodiac draw');
      this.isLoadingTicket = false;
      this.isReservationInProgress = false;
      this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');
      return;
    }
    if (this.isReservationInProgress || this.isReturningFromPayment) {
      return;
    }

    // Evitar reservas si el número es 0000
    const numeroBillete = this.value.map((v: any) => (v === -1 ? '0' : v.toString())).join('');

    if (this.selectedDraw.tipoSorteo === 4 && this.valueZodiac?.idSigno === 0) {
      this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');
      return;
    }
    const digitsToTake = this.type === 'zodiaco' || this.type === 'zodiaco-especial' ? 2 : 3;

    // Tomar los últimos dígitos del número
    const terminationDigits = numeroBillete.slice(-digitsToTake);

    this.isReservationInProgress = true;
    try {
      const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
      const counter = await this.generalS?.counterRefCode();
      const textCounter = `${idPrefix}${counter}`;
      const body = {
        lnRequestRT: {
          requestHeadTerminal: {
            // idTerminal: 1234567890123,
            idTerminal: this.credentialsS?.credentials?.id || '',
            ov: environment.userLotenal.ov,
            usuario: environment.userLotenal.user,
            password: environment.userLotenal.password,
            refCode: `termination-reservation-${this.selectedDraw.numeroSorteo}-${textCounter}`,
          },
          tipoSorteo: this.selectedDraw.tipoSorteo,
          numeroSorteo: this.selectedDraw.numeroSorteo,
          terminacion: terminationDigits,
          signo: this.valueZodiac?.idSigno || 0,
          cantBilletesReservar: 4,
          codEstado: 9,
        },
      };
      // console.log('BODY REFACTOR: ', body);

      const response = await this.sorteoS?.reservNumberTermination(body);

      const isTicketZodiac = this.sorteoS?.validateTicketLotenal(
        response,
        this.selectedDraw.numeroSorteo,
        this.selectedDraw.tipoSorteo
      );
      if (!isTicketZodiac) {
        const idTransaccion = response?.lnResponseRE?.idTransaccion || response?.lnResponseRB?.idTransaccion;
        if (idTransaccion) {
          await this.sorteoS?.releaseTickets(idTransaccion, this.selectedDraw?.numeroSorteo);
        }

        this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');

        return;
      }

      this.reservationResult.emit(response);
      this.lastReservation = {
        tipoSorteo: this.selectedDraw.tipoSorteo,
        numeroSorteo: this.selectedDraw.numeroSorteo,
        numeroBillete,
        signo: this.valueZodiac?.idSigno || 0,
      };

      const billetes = response?.lnResponseRE?.billete || [];
      const hayDiferencia = billetes.some((b: any) => this.value.join('') !== b.numeroBillete.toString());

      if (hayDiferencia) {
        this.emptyNumber.emit('El número seleccionado no se encontró. Te sugerimos otro.');
      } else {
        this.emptyNumber.emit(' ');
      }
      return response;
    } catch (error) {
      console.error('Error en la reserva:', error);
      return this.totalS.validateMessageIgt({ errorRetries: true });
    } finally {
      this.isLoadingTicket = false;
      this.isReservationInProgress = false;
    }
  }

  async makeGhostReservation(draw: any) {
    if (!draw) return;

    // if (this.valueZodiac?.idSigno === null && this.selectedDraw.tipoSorteo === 4) {
    //   console.log('reservExactNumber: signo is null for zodiac draw');
    //   this.isLoadingTicket = false;
    //   this.isReservationInProgress = false;
    //   this.emptyNumber.emit(' Ha habido un error al reservar el número, por favor intenta nuevamente.');
    //   return;
    // }

    const numeroBillete = this.value.map((v: any) => (v === -1 ? '0' : v.toString())).join('');
    if (numeroBillete === Array(this.value.length).fill('0').join('')) {
      return;
    }
    try {
      const idPrefix = this.credentialsS?.credentials?.id.slice(0, 4);
      const counter = await this.generalS?.counterRefCode();
      const textCounter = `${idPrefix}${counter}`;
      const body = {
        lnRequestRB: {
          requestHeadTerminal: {
            // idTerminal: 1234567890123,
            idTerminal: this.credentialsS?.credentials?.id || '',
            ov: environment.userLotenal.ov,
            usuario: environment.userLotenal.user,
            password: environment.userLotenal.password,
            refCode: `exact-reservation-${draw.numeroSorteo}-${textCounter}`,
          },
          tipoSorteo: draw.tipoSorteo, // Usar el tipoSorteo del sorteo adelantado
          numeroSorteo: draw.numeroSorteo, // Usar el numeroSorteo del sorteo adelantado
          numeroBillete: numeroBillete,
          signo: this.valueZodiac?.idSigno || 0,
          cantBilletesReservar: 4,
          codEstado: 9,
        },
      };
      // console.log('BODY REFACTOR: ', body);
      const response = await this.sorteoS?.reservExactNumber(body);
      const isTicketZodiac = this.sorteoS?.validateTicketLotenal(
        response,
        this.selectedDraw.numeroSorteo,
        this.selectedDraw.tipoSorteo
      );
      if (!isTicketZodiac) {
        const idTransaccion = response?.lnResponseRE?.idTransaccion || response?.lnResponseRB?.idTransaccion;
        if (idTransaccion) {
          await this.sorteoS?.releaseTickets(idTransaccion, this.selectedDraw?.numeroSorteo);
        }

        this.emptyNumber.emit(' Ha habido un error al buscar el número, por favor intenta nuevamente.');

        return;
      }

      this.ghostReservationResult.emit(response);
    } catch (error) {
      console.error('Error en la reserva:', error);
    }
  }

  async showAlert(headerKey: string, messageKey: string) {
    // Traduce las claves headerKey y messageKey
    const header = await this.translate.get(headerKey).toPromise();
    const message = await this.translate.get(messageKey).toPromise();
    const acceptText = await this.translate.get('Aceptar').toPromise();

    const alert = await this.alertCtrl.create({
      header,
      message,
      buttons: [acceptText],
    });
    await alert.present();
  }

  addToFavorite() {
    log.info('Adding to favorites:', this.value, this.type, this.valueZodiac);
    if (this.type) {
      this.sorteoS?.saveFavorite(this.value, this.type, this.valueZodiac);
    } else {
      log.error('SorteoType is undefined and cannot be passed to saveFavorite.');
    }

    this.showAlert('ALERT.FAVORITE', 'ALERT.FAVORITE_SAVED');
  }
  getZodiacId(signo: string): number {
    const zodiacSigns = [
      { name: 'Aries', icon: 'aries', idSigno: 1 },
      { name: 'Tauro', icon: 'taurus', idSigno: 2 },
      { name: 'Geminis', icon: 'gemini', idSigno: 3 },
      { name: 'Cancer', icon: 'cancer', idSigno: 4 },
      { name: 'Leo', icon: 'leo', idSigno: 5 },
      { name: 'Virgo', icon: 'virgo', idSigno: 6 },
      { name: 'Libra', icon: 'libra', idSigno: 7 },
      { name: 'Escorpion', icon: 'scorpio', idSigno: 8 },
      { name: 'Sagitario', icon: 'sagittarius', idSigno: 9 },
      { name: 'Capricornio', icon: 'capricorn', idSigno: 10 },
      { name: 'Acuario', icon: 'aquarius', idSigno: 11 },
      { name: 'Piscis', icon: 'pisces', idSigno: 12 },
    ];

    const zodiac = zodiacSigns.find((z) => z.name.toLowerCase() === signo.toLowerCase());
    return zodiac ? zodiac.idSigno : 0;
  }
  getZodiacNameInEnglish(signo: string): string {
    const zodiacSigns = [
      { name: 'Aries', icon: 'aries', idSigno: 1 },
      { name: 'Tauro', icon: 'taurus', idSigno: 2 },
      { name: 'Geminis', icon: 'gemini', idSigno: 3 },
      { name: 'Cancer', icon: 'cancer', idSigno: 4 },
      { name: 'Leo', icon: 'leo', idSigno: 5 },
      { name: 'Virgo', icon: 'virgo', idSigno: 6 },
      { name: 'Libra', icon: 'libra', idSigno: 7 },
      { name: 'Escorpion', icon: 'scorpio', idSigno: 8 },
      { name: 'Sagitario', icon: 'sagittarius', idSigno: 9 },
      { name: 'Capricornio', icon: 'capricorn', idSigno: 10 },
      { name: 'Acuario', icon: 'aquarius', idSigno: 11 },
      { name: 'Piscis', icon: 'pisces', idSigno: 12 },
    ];

    const zodiac = zodiacSigns.find((z) => z.name.toLowerCase() === signo.toLowerCase());
    return zodiac ? zodiac.icon : '';
  }

  pausePicker() {
    if (this.isLoadingTicket) {
      this.loadingTicket.emit(true);
    }
  }
  getHighlightBackground(type: string): string {
    const colors: Record<string, string> = {
      zodiaco: '#fcf5f8',
      'zodiaco-especial': '#ffedde',
      mayor: '#ffedcc',
      magno: '#f1e3fd',
      gordito: '#ffd9d9',
      'gran-especial': '#fce0ef',
      especial: '#cdeefb',
      superior: '#f0fed4',
    };
    return colors[type] || '#34643f0e';
  }

  ngOnDestroy() {
    //console.log('PickerComponent ionDidLeave');
  }
}
